import React, { useContext, useState } from "react";
import {
  faAdd,
  faCancel,
  faCheckCircle,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MessageModal from "./MessageModal";
import useSWR from "swr";
import TableTotalNCost from "./TableTotalNCost";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import TopActionMenus from "./TopActionMenus";
import SearchFilter from "./SearchFilter";
import { NavigationContext } from "navigation-react";
import LoaderAnimation from "./LoaderAnimationLarge";
import SecureLS from "secure-ls";
import AddCTScanRequestRegister from "./AddCTScanRequestRegister";
import EditCTScanRequestRegister from "./EditCTScanRequestRegister";
import { AppContext } from "./AppContext";

const ls = new SecureLS({ encodingType: "aes" });

function parseDate(dateStr) {
  if (!dateStr) return null;

  const isoDate = new Date(dateStr);
  if (!isNaN(isoDate.getTime())) return isoDate;

  const parts = dateStr.split("/");
  if (parts.length === 3) {
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);
    const parsedDate = new Date(year, month, day);
    if (!isNaN(parsedDate.getTime())) return parsedDate;
  }

  return null;
}

const CtScanRequestRegister = () => {
  const { stateNavigator } = useContext(NavigationContext);
  const [editRequestData, setEditRequestData] = useState("");
  const [modalAddRequest, setModalAddRequest] = useState(false);
  const [modalEditRequest, setModalEditRequest] = useState(false);
  const [isMessageModalIsNotOk, setIsMessageModalIsNotOk] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [modalMessages, setModalMessages] = useState("");
  const [isMessageModalError, setIsMessageModalError] = useState(false);
  const [modalSuccessMsg, setModalSuccessMsg] = useState(false);
  const { setSelectedData } = useContext(AppContext);

  const perm = ls.get("currentuserrole") || [];
  console.log("permissions::", perm);

  const usercsrf_token = ls.get("usercsrf_token");

  const fetcher = (url) =>
    fetch(url, {
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": usercsrf_token,
      },
    })
      .then((res) => res.json())
      .then((data) => (Array.isArray(data) ? data : [data]));

  const [searchTerm, setSearchTerm] = useState("");
  const [requestStartDate, setRequestStartDate] = useState("");
  const [requestEndDate, setRequestEndDate] = useState("");
  const [reportedStartDate, setReportedStartDate] = useState("");
  const [reportedEndDate, setReportedEndDate] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const {
    data: ctrequestsData,
    error: ctrequestsDataError,
    isLoading: ctrequestsDataLoading,
  } = useSWR(`${process.env.REACT_APP_CT_SCAN_REQUEST_URL}`, fetcher);
  console.log(
    "CT SCAN REQUEST DATA FROM CTSCANREQUESTREGISTER",
    ctrequestsData
  );

  const filteredData = Array.isArray(ctrequestsData)
    ? ctrequestsData.filter((request) => {
        const matchesSearchTerm =
          request.field_patient_id
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          request.title_1?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          request.field_investigation_price
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_requester_payment_commissi
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_requester_payment_commissi_1
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_assigned_radiologist
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase());

        const matchesStatus =
          !statusFilter ||
          request.field_ct_scan_request_status?.toLowerCase() ===
            statusFilter.toLowerCase();

        const requestDate = parseDate(request.created);
        const reqStart = requestStartDate ? new Date(requestStartDate) : null;
        const reqEnd = requestEndDate ? new Date(requestEndDate) : null;

        const reportedDate = parseDate(request.created_2);
        const repStart = reportedStartDate ? new Date(reportedStartDate) : null;
        const repEnd = reportedEndDate ? new Date(reportedEndDate) : null;

        if (reqStart) reqStart.setHours(0, 0, 0, 0);
        if (reqEnd) reqEnd.setHours(23, 59, 59, 999);
        if (requestDate) requestDate.setHours(12, 0, 0, 0);

        if (repStart) repStart.setHours(0, 0, 0, 0);
        if (repEnd) repEnd.setHours(23, 59, 59, 999);
        if (reportedDate) reportedDate.setHours(12, 0, 0, 0);

        const isInRequestDateRange =
          (!reqStart || (requestDate && requestDate >= reqStart)) &&
          (!reqEnd || (requestDate && requestDate <= reqEnd));

        const isInReportedDateRange =
          (!repStart || (reportedDate && reportedDate >= repStart)) &&
          (!repEnd || (reportedDate && reportedDate <= repEnd));

        return (
          matchesSearchTerm &&
          matchesStatus &&
          isInRequestDateRange &&
          isInReportedDateRange
        );
      })
    : [];

  const toggleModalAddRequest = () => setModalAddRequest(!modalAddRequest);
  const toggleModalEditRequest = () => setModalEditRequest(!modalEditRequest);
  const toggleModalSuccessMsg = () => setModalSuccessMsg(!modalSuccessMsg);
  const toggleModalError = () => setIsMessageModalError(!isMessageModalError);
  const toggleModalIsNotOk = () =>
    setIsMessageModalIsNotOk(!isMessageModalIsNotOk);

  if (ctrequestsDataError) {
    return (
      <LoaderAnimation
        loadingTxt={`Check your internet connection and try again!, ${ctrequestsDataError}`}
      />
    );
  }

  const getStatusStyle = (status) => {
    switch (status) {
      case "Pending":
        return { color: "red" };
      case "Assigned":
        return { color: "yellow" };
      case "Completed":
        return { color: "green" };
      default:
        return { color: "gray" };
    }
  };

  if (ctrequestsDataLoading) {
    return <LoaderAnimation loadingTxt="Loading CT scan requests..." />;
  }

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="patient-register">
          <TopActionMenus
            AddTitle="CT Scan Request Register"
            onClick={toggleModalAddRequest}
            buttonLabel="New request"
            onClickIcon={`${faAdd}`}
          />

          <SearchFilter
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            requestStartDate={requestStartDate}
            setRequestStartDate={setRequestStartDate}
            requestEndDate={requestEndDate}
            setRequestEndDate={setRequestEndDate}
            reportedStartDate={reportedStartDate}
            setReportedStartDate={setReportedStartDate}
            reportedEndDate={reportedEndDate}
            setReportedEndDate={setReportedEndDate}
          />

          <table>
            <thead>
              <tr>
                <td>Patient ID</td>
                <td>Patient Full Name</td>
                <td>Investigation</td>
                <td>Investigation Cost (GHC)</td>
                <td>Request Fee (GHC)</td>
                <td>Request Fee (%)</td>
                <td>Request Date</td>
                <td>Report Date</td>
                {/* <td>Request Status</td> */}
                <td>Report Status</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((ctrequests) => (
                  <tr key={ctrequests.nid}>
                    <td>{ctrequests.field_patient_id}</td>
                    <td>
                      {ctrequests.title === "Patient yet to be attached" ? (
                        <span className="tableyettobeadded">
                          Patient yet to be attached
                        </span>
                      ) : (
                        ctrequests.title
                      )}
                    </td>
                    <td>{ctrequests.investigation}</td>
                    <td>{ctrequests.field_investigation_price}</td>
                    <td>{ctrequests.field_requester_payment_commissi}</td>
                    <td>{ctrequests.field_requester_payment_com_perc}</td>
                    <td>{ctrequests.request_date}</td>
                    <td>{ctrequests.report_date}</td>
                    {/* <td>{ctrequests.field_ct_scan_request_status}</td> */}
                    <td
                      style={getStatusStyle(
                        ctrequests.field_ct_scan_report_status
                      )}
                    >
                      {ctrequests.field_ct_scan_report_status}
                    </td>
                    <td className="formActionBtn">
                      <button
                        className="btn-modal"
                        onClick={() => {
                          setEditRequestData(ctrequests);
                          toggleModalEditRequest();
                        }}
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => {
                          const reportData = {
                            request_nid: ctrequests.request_nid,
                            request_uuid: ctrequests.request_uuid,
                            patient_fullname: ctrequests.patient_fullname,
                            patient_field_patient_id:
                              ctrequests.field_patient_id,
                            patient_nid: ctrequests.patient_nid,
                            patient_gender: ctrequests.field_gender,
                            patient_date_of_birth:
                              ctrequests.field_date_of_birth,
                            requester_first_name:
                              ctrequests.requester_first_name,
                            requester_last_name: ctrequests.requester_last_name,
                            request_date_created: ctrequests.request_date,
                            report_date_created: ctrequests.report_date,
                            report_nid: ctrequests.report_nid,
                            report_field_ct_scan_report_status:
                              ctrequests.field_ct_scan_report_status,
                            report_report_main_title:
                              ctrequests.report_main_title,
                            report_field_specialty: ctrequests.field_specialty,
                            report_field_ct_scan_report_technique:
                              ctrequests.field_ct_scan_report_technique,
                            report_field_ct_scan_report_findings:
                              ctrequests.field_ct_scan_report_findings,
                            report_field_ct_scan_report_impression:
                              ctrequests.field_ct_scan_report_impression,
                            request_investigation: ctrequests.investigation,
                            request_clinical_diag:
                              ctrequests.field_ct_scan_clinical_diagnosis,
                            request_comments: ctrequests.field_ct_scan_comments,
                            report_uuid: ctrequests.report_uuid,
                          };
                          setSelectedData(reportData);
                          stateNavigator.navigate("viewctscanreportregister");
                        }}
                      >
                        View report
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center" }}>
                    No matching records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {filteredData.length > 0 && (
            <TableTotalNCost
              noOfReportLable="Number of request :"
              noOfReportLength={filteredData.length}
              totalRequestFeeCostLable="Total Request Fee :"
              totalRequestFeeCostValue={filteredData.reduce((total, report) => {
                const amount =
                  Number(report?.field_requester_payment_commissi) || 0;
                return total + amount;
              }, 0)}
            />
          )}

          {/* --- Add CT Request Modal --- */}
          {modalAddRequest && (
            <div className="modal">
              <div className="overlay"></div>
              <div className="modal-content">
                <div className="modal-body">
                  <div className="modal-header">
                    <p>Add new CT - scan request</p>
                    <button
                      className="close-modal"
                      onClick={toggleModalAddRequest}
                    >
                      <FontAwesomeIcon icon={faClose} />
                    </button>
                  </div>
                  <AddCTScanRequestRegister />
                </div>
              </div>
            </div>
          )}

          {/* --- Edit CT Request Modal --- */}
          {modalEditRequest && (
            <div className="modal">
              <div className="overlay"></div>
              <div className="modal-content">
                <div className="modal-body">
                  <div className="modal-header">
                    <p>{`Update ${editRequestData.patient_fullname} request`}</p>
                    <button
                      className="close-modal"
                      onClick={toggleModalEditRequest}
                    >
                      <FontAwesomeIcon icon={faClose} />
                    </button>
                  </div>
                  <EditCTScanRequestRegister
                    requestData={editRequestData}
                    request_nid={ctrequestsData?.[0]?.request_nid}
                    request_investigation_nid={
                      ctrequestsData?.[0]?.investigation_nid
                    }
                    request_ctscan_clinical_diag={
                      ctrequestsData?.[0]?.field_ct_scan_clinical_diagnosis
                    }
                    request_ctscan_comments={
                      ctrequestsData?.[0]?.field_ct_scan_comments
                    }
                    setModalSuccessMsg={setModalSuccessMsg}
                    setIsMessageModalError={setIsMessageModalError}
                  />
                </div>
              </div>
            </div>
          )}

          {/* --- Success Message --- */}
          {modalSuccessMsg && (
            <MessageModal
              leftIcon={faCheckCircle}
              color="green"
              fontSize={20}
              message="Request updated successfully!"
              onClose={() => setModalSuccessMsg(false, toggleModalSuccessMsg())}
              rightIcon={faClose}
            />
          )}

          {/* --- Error Message --- */}
          {isMessageModalError && (
            <MessageModal
              leftIcon={faCancel}
              color="red"
              fontSize={20}
              message="This request is complete. Editing is not allowed."
              onClose={toggleModalError}
              rightIcon={faClose}
            />
          )}

          {/* --- Custom Message --- */}
          {isMessageModalIsNotOk && (
            <MessageModal
              leftIcon={faCancel}
              color="red"
              fontSize={20}
              message={modalMessages}
              onClose={toggleModalIsNotOk}
              rightIcon={faClose}
            />
          )}
        </div>
      </div>
      <DashboardContentFooter />
    </div>
  );
};

export default CtScanRequestRegister;
